import request from '../../config/axiosConfig';
import { GET_LIST_MB_PUSH_NOTI_TRANSACTIONS } from '../../constants/apiEndPoint';

export const getListMbPushNotiTransactionsRequest = async (data) => {
  const result = await request({ url: GET_LIST_MB_PUSH_NOTI_TRANSACTIONS, method: 'POST', data });
  return result?.data?.data;
};
